import { isElevarTrackingAllowed } from './consent.ts';
import { type ElevarEvent } from './types.ts';

declare global {
    interface Window {
        ElevarDataLayer?: ElevarEvent[];
        ElevarInvalidateContext?: () => void;
    }
}

const hasWindow = (): boolean => typeof window !== 'undefined';

if (hasWindow()) {
    window.ElevarDataLayer = window.ElevarDataLayer ?? [];
}

export function pushElevarEvent(event: ElevarEvent): void {
    if (!hasWindow()) {
        return;
    }
    if (!isElevarTrackingAllowed()) {
        return;
    }
    if (!Array.isArray(window.ElevarDataLayer)) {
        window.ElevarDataLayer = [];
    }
    window.ElevarDataLayer.push(event);
}

export function invalidateElevarContext(): void {
    if (!hasWindow()) {
        return;
    }
    // eslint-disable-next-line new-cap -- global name is defined by Elevar's script
    window.ElevarInvalidateContext?.();
}
